<template>
    <div id="demo-basic-card" class="margin-top">
        <div id="dashboard-analytics">
                <account-overview />
                <package-register />
        </div>
    </div>
</template>
<script>
import AccountOverview from '../account-overview/AccountOverview.vue'
import PackageRegister from './PackageRegister.vue'
export default {
    components: {
        AccountOverview,
        PackageRegister
    },
    data(){
        return {
        }
    },
    created(){
        
    },
}
</script>
<style scoped>

</style>